import React, { useState } from 'react';
import { ContainerFormForStatusFooter, ContainerMenu } from '../../../../components/Containers';
import HeaderTitle from '../../../../components/HeaderTitle';
import ListLinks from '../../../../components/NovoSistema/ListLinks';
import WrapperButtonsLinks from '../../../../components/NovoSistema/WrapperButtonsLinks';

export default function TemplateRelatoriosContabeis() {
  const [year, setYear] = useState('21');
  return (
    <ContainerMenu>
      <ContainerFormForStatusFooter>
        <HeaderTitle text="Relatórios Contábeis – Demonstrações Financeiras" linkIcon="/images/icons/paperFill.svg" />
        <WrapperButtonsLinks year={year} setYear={setYear} />
        <div style={{ display: 'flex' }}>
          <ListLinks
            title="DFs Individuais"
            typeDf="i"
            year={year}
            link={
              year === '20'
                ? {
                    BP1T: '',
                    BP2T: '',
                    BP3T: '',
                    BP4T: '/docs/contabil/RelatoriosContabeis/DFsIndividuais/BP 4T20.pdf',
                    DFC1T: '',
                    DFC2T: '',
                    DFC3T: '',
                    DFC4T: '/docs/contabil/RelatoriosContabeis/DFsIndividuais/DFC 4T20.pdf',
                    DVA1T: '',
                    DVA2T: '',
                    DVA3T: '',
                    DVA4T: '/docs/contabil/RelatoriosContabeis/DFsIndividuais/DVA 4T20.pdf',
                    DRE1T: '',
                    DRE2T: '',
                    DRE3T: '',
                    DRE4T: '/docs/contabil/RelatoriosContabeis/DFsIndividuais/DRE 4T20.pdf',
                    DMPL1T: '',
                    DMPL2T: '',
                    DMPL3T: '',
                    DMPL4T: '/docs/contabil/RelatoriosContabeis/DFsIndividuais/DMPL 4T20.pdf',
                    NE1T: '',
                    NE2T: '',
                    NE3T: '',
                    NE4T: '',
                  }
                : {
                    BP1T: '',
                    BP2T: '',
                    BP3T: '',
                    BP4T: '',
                    DFC1T: '',
                    DFC2T: '',
                    DFC3T: '',
                    DFC4T: '',
                    DVA1T: '',
                    DVA2T: '',
                    DVA3T: '',
                    DVA4T: '',
                    DRE1T: '',
                    DRE2T: '',
                    DRE3T: '',
                    DRE4T: '',
                    DMPL1T: '',
                    DMPL2T: '',
                    DMPL3T: '',
                    DMPL4T: '',
                    NE1T: '',
                    NE2T: '',
                    NE3T: '',
                    NE4T: '',
                  }
            }
          />
          <ListLinks
            title="DFs Consolidadas"
            typeDf="c"
            year={year}
            link={
              year === '20'
                ? {
                    BP1T: '',
                    BP2T: '',
                    BP3T: '',
                    BP4T: '',
                    DFC1T: '',
                    DFC2T: '',
                    DFC3T: '',
                    DFC4T: '',
                    DVA1T: '',
                    DVA2T: '',
                    DVA3T: '',
                    DVA4T: '',
                    DRE1T: '',
                    DRE2T: '',
                    DRE3T: '',
                    DRE4T: '',
                    DMPL1T: '',
                    DMPL2T: '',
                    DMPL3T: '',
                    DMPL4T: '',
                    NE1T: '',
                    NE2T: '',
                    NE3T: '',
                    NE4T: '',
                  }
                : {
                    BP1T: '',
                    BP2T: '',
                    BP3T: '',
                    BP4T: '',
                    DFC1T: '',
                    DFC2T: '',
                    DFC3T: '',
                    DFC4T: '',
                    DVA1T: '',
                    DVA2T: '',
                    DVA3T: '',
                    DVA4T: '',
                    DRE1T: '',
                    DRE2T: '',
                    DRE3T: '',
                    DRE4T: '',
                    DMPL1T: '',
                    DMPL2T: '',
                    DMPL3T: '',
                    DMPL4T: '',
                    NE1T: '',
                    NE2T: '',
                    NE3T: '',
                    NE4T: '',
                  }
            }
          />
        </div>
      </ContainerFormForStatusFooter>
    </ContainerMenu>
  );
}
